import classNames from 'classnames'
import React, { useState } from 'react'

import { Spin } from 'antd'


function Input({
    type = 'text',
    name,
    label = '',
    value,
    placeholder,
    isLoading,
    helpText,
    error,
    onChange,
    disabled = false,
    required,
    isSelected,
    handleSelect,
    tooltip,
    ...rest
}) {
    const [showPassword, setShowPassword] = useState(false)

    const handleTogglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword)
    }
    // useEffect(() => {
    //   if (type === 'number' && !value) {
    //     // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    //     onChange ? onChange(name, '0') : null
    //   }
    // }, [])

    return (
        <div className="w-full space-y-0.5">
            {label && (
                <>
                    <label
                        className="inline-block w-full text-sm text-gray-700 form-label flex py-0.5"
                        htmlFor={name}
                    >
                        {label}
                        {required && <span className="text-red-500">*</span>}
                        {tooltip && (
                            <div className="relative group ml-2">
                                {/* <FontAwesomeIcon icon={faInfoCircle} className="text-gray-400 cursor-pointer" /> */}
                                <div className="w-[100px] absolute bottom-full px-1.5 pt-0.5 pb-1 m-2 mx-auto text-xs text-gray-100 transition-opacity opacity-0 group-hover:opacity-100 bg-gray-700 text-white text-xs rounded whitespace-no-wrap">
                                    {tooltip}
                                </div>
                            </div>
                        )}
                    </label>
                </>
                // -translate-x-1/2 translate-y-full bg-gray-800 rounded-md left-1/2 z-40
            )}
            {isLoading ? (
                <Spin />
            ) : (
                <div className="relative">
                    <input
                        id={name}
                        name={name}
                        defaultValue={0}
                        value={value}
                        placeholder={placeholder}
                        type={type === 'password' && showPassword ? 'text' : type}
                        onChange={(e) => (onChange ? onChange(name, e.target.value) : null)}
                        className={classNames(
                            'form-control block w-full px-3 py-1 text-sm font-normal text-gray-800 bg-white bg-clip-padding border border-solid border-gray-200 rounded-md transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-primary focus:outline-none disabled:bg-[#fafbfc]',
                            !disabled && label && 'shadow-all-side',
                            // error && ERROR_CLASS,
                            !value &&
                            placeholder &&
                            `before:content-['${placeholder}'] before:mr-4 before:text-gray-400`
                        )}
                        disabled={disabled}
                        {...rest}
                    />
                    {type === 'password' && (
                        <button
                            type="button"
                            onClick={handleTogglePasswordVisibility}
                            className="absolute inset-y-0 right-3 flex items-center px-2 text-sm text-gray-600 focus:outline-none"
                        >
                            {/* <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} /> */}
                        </button>
                    )}
                </div>
            )}

            {error && <p className="mt-1 text-xs text-red-500 md:text-sm">{error}</p>}
            {helpText && <p className="mt-1 text-xs text-gray-500 md:text-sm">{helpText}</p>}
        </div>
    )
}

export default Input
